Vue.component('smaakwijzer', {
    data() {
        return {
            currentQuestion: 1,
            questions: tasteGuideQuestions,
        };
    },
    mounted() {
        // Set 'givenAnwser' property for each question
        this.questions.forEach((question) => {
            Vue.set(question, 'givenAnswer', null);
        });
    },
    computed: {
        activeQuestion() {
            return this.questions[this.currentQuestion - 1];
        },
    },
    methods: {
        prevQuestion() {
            this.currentQuestion -= 1;
        },
        nextQuestion() {
            if (this.currentQuestion === this.questions.length) {
                this.submitAnswers();
            } else {
                this.currentQuestion += 1;
            }
        },
        gotoQuestion(question, index) {
            if (question.givenAnswer || index < this.currentQuestion) {
                this.currentQuestion = index + 1;
            }
        },
        submitAnswers() {
            const selectedAnswers = this.questions.map((question) => {
                const result = {};
                result.question = question.id;
                result.answer = question.givenAnswer;
                return result;
            });

            fetch('/api/tasteguide', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
                body: JSON.stringify(selectedAnswers),
            }).then(response => response.json()).then((response) => {
                window.location.href = response.url;
            });
        },
    }
});